import useBoxLabelAndProductionHoldForm from "../components/form/box-label-and-production-hold/useBoxLabelAndProductionHoldForm";

function ProductionHoldPage() {
  const { form } = useBoxLabelAndProductionHoldForm({
    title: "Production Hold Generator",
    apiUrl: "production-hold-label",
    printText: "Print label",
    isProductionHold: true,
  });

  return <>{form}</>;
}

export default ProductionHoldPage;
